export class EnrolmentDay {
    am: boolean = false;
    pm: boolean = false;
}

export class IEnrolment {
    monday: EnrolmentDay;
    tuesday: EnrolmentDay;
    wednesday: EnrolmentDay;
    thursday: EnrolmentDay;
    friday: EnrolmentDay;
}

export class Enrolment implements IEnrolment {
    monday: EnrolmentDay = new EnrolmentDay();
    tuesday: EnrolmentDay = new EnrolmentDay();
    wednesday: EnrolmentDay = new EnrolmentDay();
    thursday: EnrolmentDay = new EnrolmentDay();
    friday: EnrolmentDay = new EnrolmentDay();

    constructor(data: string) {
        data.split(",").forEach((enrolmentDayRaw) => {
            if (!enrolmentDayRaw) return;

            const [day, time] = enrolmentDayRaw.split("-");
            const dayKey = day.trim().toLowerCase();
            const timeKey = time.trim().toLowerCase() === "morning" ? "am" : "pm";
            const enrolmentDay = (this as any)[dayKey] as EnrolmentDay;

            enrolmentDay[timeKey] = true;
            (this as any)[dayKey] = enrolmentDay;
        });
    }
}